/**
 * Global styles for the Hedra Avatar Widget
 */
export const widgetStyles = `
  #hedra-avatar-widget-root {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    box-sizing: border-box;
  }

  #hedra-avatar-widget-root *,
  #hedra-avatar-widget-root *::before,
  #hedra-avatar-widget-root *::after {
    box-sizing: inherit;
  }

  #hedra-avatar-widget-root .widget-container {
    position: fixed;
    z-index: 9999;
    width: 400px;
    height: 600px;
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }

  #hedra-avatar-widget-root .widget-container.bottom-right {
    bottom: 20px;
    right: 20px;
  }

  #hedra-avatar-widget-root .widget-container.bottom-left {
    bottom: 20px;
    left: 20px;
  }

  #hedra-avatar-widget-root .video-element {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  #hedra-avatar-widget-root .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(10px);
  }

  #hedra-avatar-widget-root .placeholder-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  #hedra-avatar-widget-root .overlay-content {
    position: relative;
    z-index: 1;
    text-align: center;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #hedra-avatar-widget-root .start-button {
    background: white;
    color: black;
    border: none;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    font-size: 32px;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.4);
  }

  #hedra-avatar-widget-root .start-button:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 24px rgba(102, 126, 234, 0.6);
  }

  #hedra-avatar-widget-root .start-button:active {
    transform: scale(0.95);
  }

  .start-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .loading-spinner {
    width: 48px;
    height: 48px;
    border: 4px solid rgba(255, 255, 255, 0.2);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  .loading-text {
    color: white;
    margin-top: 16px;
    font-size: 14px;
  }

  .error-container {
    max-width: 280px;
  }

  .error-icon {
    font-size: 48px;
    margin-bottom: 16px;
  }

  .error-message {
    color: white;
    font-size: 14px;
    margin-bottom: 20px;
    line-height: 1.5;
  }

  .retry-button {
    background: white;
    color: #333;
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
  }

  .retry-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  .retry-button:active {
    transform: translateY(0);
  }

  .status-indicator {
    position: absolute;
    top: 12px;
    left: 12px;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: white;
    z-index: 10;
  }

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #10b981;
  }

  .status-dot.listening {
    background: #3b82f6;
    animation: pulse 2s ease-in-out infinite;
  }

  .status-dot.speaking {
    background: #8b5cf6;
    animation: pulse 1s ease-in-out infinite;
  }

  .status-dot.processing {
    background: #f59e0b;
    animation: pulse 1.5s ease-in-out infinite;
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }

  .controls {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 12px;
    z-index: 10;
  }

  .control-button {
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(10px);
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    width: 56px;
    height: 56px;
    font-size: 24px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .control-button:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.4);
    transform: scale(1.05);
  }

  .control-button:active {
    transform: scale(0.95);
  }

  .control-button:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  .control-button.active {
    background: #ef4444;
    border-color: #ef4444;
  }

  .control-button.mic-button {
    background: rgba(59, 130, 246, 0.8);
    border-color: #3b82f6;
    font-size: 12px;
    font-weight: 600;
  }

  .control-button.mic-button:hover {
    background: rgba(59, 130, 246, 0.9);
  }

  .control-button.mic-button.recording {
    background: #ef4444;
    border-color: #ef4444;
    animation: pulse 0.5s ease-in-out infinite;
  }

  .countdown-badge {
    position: absolute;
    bottom: 90px;
    right: 20px;
    background: rgba(245, 158, 11, 0.95);
    color: white;
    padding: 8px 16px;
    border-radius: 16px;
    font-size: 13px;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    z-index: 100;
    animation: pulse 1s ease-in-out infinite;
    backdrop-filter: blur(10px);
  }

  .status-message {
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(239, 68, 68, 0.95);
    color: white;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    z-index: 100;
    backdrop-filter: blur(10px);
    animation: fadeInOut 3s ease-in-out forwards;
    text-align: center;
    max-width: 80%;
  }

  @keyframes fadeInOut {
    0% { opacity: 0; transform: translateX(-50%) translateY(-10px); }
    10% { opacity: 1; transform: translateX(-50%) translateY(0); }
    80% { opacity: 1; transform: translateX(-50%) translateY(0); }
    100% { opacity: 0; transform: translateX(-50%) translateY(-10px); }
  }

  .hidden {
    display: none !important;
  }
`;
